import { render, staticRenderFns } from "./NiveisAcessoCreate.vue?vue&type=template&id=217bbad0&"
import script from "./NiveisAcessoCreate.vue?vue&type=script&lang=js&"
export * from "./NiveisAcessoCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports